"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Construct URI with query parameters
 */
class UriBuilder {
    constructor(base) {
        this.base = base;
        this.args = new Array();
        this.paths = new Array();
    }
    pathSegment(name) {
        this.paths.push(encodeURIComponent(name));
        return this;
    }
    queryParam(name, value) {
        if (typeof value !== 'undefined') {
            this.args.push(encodeURIComponent(name) + '=' + encodeURIComponent(value));
        }
        return this;
    }
    build() {
        let result = this.base;
        if (this.paths.length) {
            result += '/' + this.paths.join('/');
        }
        if (this.args.length) {
            result += '?' + this.args.join('&');
        }
        return result;
    }
}
exports.UriBuilder = UriBuilder;
